export default __webpack_public_path__ + "static/media/warning.ffb62c92.png";